import Vuex from 'vuex'
import config from './modules/config'
import drafts from './modules/drafts'
import posts from './modules/posts'
import tributes from './modules/tributes'
import users from './modules/users'

const state = {
  ...config.state,
  ...drafts.state,
  ...posts.state,
  ...tributes.state,
  ...users.state,
}

const getters = {
  ...config.getters,
  ...drafts.getters,
  ...posts.getters,
  ...tributes.getters,
  ...users.getters,
}

const mutations = {
  ...config.mutations,
  ...drafts.mutations,
  ...posts.mutations,
  ...tributes.mutations,
  ...users.mutations,
}

const actions = {}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
})
